import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fund-income-info',
  templateUrl: './income-info.component.html',
  styleUrls: ['./income-info.component.scss']
})
export class IncomeInfoComponent implements OnInit {
  @Input() page: any;

  constructor() { }

  ngOnInit() {
  }

}
